const basic = {
    // prod
    baseUrl: "https://tms-api.speedd.hk",
    reportBaseUrl: "https://report-api.speedd.hk",
    wmsBaseUrl: "https://hswmspdt.azurewebsites.net/api/",

    // sit | uat
    // baseUrl: "https://tms-api-sit.speedd.hk",
    // reportBaseUrl: "https://report-api-sit.speedd.hk", 
    // wmsBaseUrl: "https://hswmsuat.azurewebsites.net/api/",
    
    // local
    // baseUrl: "http://192.168.3.35:3009",
    // reportBaseUrl: "http://192.168.3.35:3008", 
    
};

export default basic;
